import { Box, Button, Form, TextInput, Text, Image } from "grommet";
import React, { useEffect } from "react";

const SubjectView = ({ subject, onSelect }) => {
    return (
        <Box>
            <Box direction="row">
                <Box>
                    <Text>{subject.name}</Text>
                    <Text size="small" color={"background-front"}>
                        {subject.id}
                    </Text>
                </Box>
            </Box>
            <Box direction="row" justify="evenly">
                <Box>
                    <Text>Source Images</Text>
                    <Box direction="row" justify="between">
                        <Box direction="row" gap="small" height={"200px"} pad={"xsmall"}>
                            {subject.sourcePhotos && <Image key={subject.sourcePhotos[subject.sourcePhotos?.length - 1]} src={subject.sourcePhotos[subject.sourcePhotos?.length - 1]} height={"150px"}></Image>}
                        </Box>
                    </Box>
                </Box>
                <Box>
                    <Text>Share Images</Text>
                    <Box direction="row" justify="between">
                        <Box direction="row" gap="small" height={"200px"} pad={"xsmall"}>
                            {subject.sharePhotos && <Image key={subject.sharePhotos[subject.sharePhotos?.length - 1]} src={subject.sharePhotos[subject.sharePhotos?.length - 1]} height={"150px"}></Image>}
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Button label="View" onClick={() => onSelect(subject.id)}></Button>
        </Box>
    );
};

export default SubjectView;
